import { useState } from "react";
import WhatsAppLink from "@/components/feature/WhatsAppLink";

export interface FaqItemData {
  question: string;
  answer: string;
  waMessage: string;
}

export default function FaqAccordion({ items }: { items: FaqItemData[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-300/60 border-y border-background-300/60">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={item.question}>
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 py-5 text-left"
            >
              <span className="font-heading text-lg leading-snug text-primary-800 md:text-xl">
                {item.question}
              </span>
              <span
                className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border transition-colors ${
                  isOpen
                    ? "border-accent-500 bg-accent-500 text-background-50"
                    : "border-accent-500 text-accent-600"
                }`}
                aria-hidden="true"
              >
                <i className={`ri-${isOpen ? "subtract" : "add"}-line text-lg`}></i>
              </span>
            </button>

            {isOpen && (
              <div className="pb-6 pr-4 text-foreground-600">
                <p className="leading-relaxed">{item.answer}</p>
                <WhatsAppLink
                  message={item.waMessage}
                  label="Bu konuda bilgi alın"
                  variant="ghost"
                  size="sm"
                  icon
                  sourceSection="faq"
                  className="-ml-1 mt-2"
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}